import { DateTime } from 'luxon';
import { Time } from '@instinet-analytics/core-lib';
import { useMemo } from 'react';

export type TimeRangeStreamData = {
    startTimestamp: number;
    endTimestamp: number;
};

interface UseTimeRangeRet {
    dataFromTime: Time | undefined;
    dataEndTime: Time | undefined;
    userChosenFromTime: Time | undefined;
    userChosenEndTime: Time | undefined;
    fromTime: Time | undefined;
    endTime: Time | undefined;
    userOverridden: boolean;
}

export const useTimeRange: (
    data: TimeRangeStreamData,
    component: { startTime?: Time | undefined; endTime?: Time | undefined }
) => UseTimeRangeRet = (data, component) => {
    const dataStartDateTime = data?.startTimestamp
        ? DateTime.fromMillis(data.startTimestamp)
        : undefined;
    const dataEndDateTime = data?.endTimestamp
        ? DateTime.fromMillis(data.endTimestamp)
        : undefined;

    return useMemo(() => {
        const dataFromTime: Time | undefined = dataStartDateTime
            ? { hours: dataStartDateTime.hour, mins: dataStartDateTime.minute }
            : undefined;
        const dataEndTime: Time | undefined = dataEndDateTime
            ? { hours: dataEndDateTime.hour, mins: dataEndDateTime.minute }
            : undefined;
        const userChosenFromTime = component?.startTime;
        const userChosenEndTime = component?.endTime;

        const fromTime = userChosenFromTime ?? dataFromTime;
        const endTime = userChosenEndTime ?? dataEndTime;

        return {
            dataFromTime,
            dataEndTime,
            userChosenFromTime,
            userChosenEndTime,
            fromTime,
            endTime,
            userOverridden: !!(userChosenFromTime || userChosenEndTime),
        };
    }, [component, dataStartDateTime, dataEndDateTime]);
};
